import { runAction } from "./client";
import { Key } from "../models";

export interface UserResult
{
    IsAdministrator: boolean;
    IsDivisionAware: boolean;
    IsIsolatedPremise: boolean;
    LastDivisionId: number;
    Locale: string;
    DefaultTimezoneId: Key;
    IsEmailNotificationEnabled: boolean;
}

export interface GetUserInfoFn
{
    (): Promise<UserResult>; 
}

export const getUserInfo: GetUserInfoFn = () => {
    return runAction<UserResult>('/action/GetUserInfo', {});

};


// WEBPACK FOOTER //
// ./src/rest/user.ts